var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.441,
    height: 15.297,
    viewBox: "0 0 18.441 15.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44543",
    "data-name": "Group 44543",
    transform: "translate(-80.444 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42452",
    "data-name": "Group 42452",
    transform: "translate(78.022 -2.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "translate(2.422 3.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32380",
    "data-name": "Path 32380",
    d: "M1.959,11.93a.759.759,0,1,0,.759.759.759.759,0,0,0-.759-.759Z",
    transform: "translate(-1.2 -7.42)",
    fill: "#29f87e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32381",
    "data-name": "Path 32381",
    d: "M33.947,12.693a.753.753,0,1,1-.753-.753A.753.753,0,0,1,33.947,12.693Z",
    transform: "translate(-15.506 -7.425)",
    fill: "#29f87e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32382",
    "data-name": "Path 32382",
    d: "M17.588,5.117a.753.753,0,1,0-.748-.753.753.753,0,0,0,.748.753Z",
    transform: "translate(-8.362 -3.61)",
    fill: "#29f87e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32383",
    "data-name": "Path 32383",
    d: "M18.827,12.871a10.088,10.088,0,0,0-1.968.672,11.693,11.693,0,0,0-2.168,1.35A10.408,10.408,0,0,1,13.466,13,26.519,26.519,0,0,1,12.1,9.434a.574.574,0,0,0-1.084,0A26.248,26.248,0,0,1,9.65,13a10.132,10.132,0,0,1-1.225,1.886,12.365,12.365,0,0,0-2.168-1.344,10.207,10.207,0,0,0-1.919-.672.539.539,0,0,0-.613.759,30.3,30.3,0,0,1,2.168,7.318.542.542,0,0,0,.542.45h10.3a.542.542,0,0,0,.542-.45,30.3,30.3,0,0,1,2.168-7.318.54.54,0,0,0-.618-.759ZM7.687,19.62a.6.6,0,1,1,.6-.6.6.6,0,0,1-.6.6Zm3.876,0a.6.6,0,1,1,.545-.6A.6.6,0,0,1,11.563,19.62Zm3.881,0a.6.6,0,1,1,.6-.6.6.6,0,0,1-.6.6Z",
    transform: "translate(-2.332 -6.101)",
    fill: "#29f87e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premiumIcon.64baa4384f0e971ec95f85597bbd1741.svg";
export { ForwardRef as ReactComponent };